import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { ListingStatusType } from '../types';
import { StatsDataEntityInterface } from '../../../stats/data/entity.interface';
import { StatsDataAgentInterface } from '../../../stats/data/agent.interface';
import { StatsDataPropertyInterface } from '../../../stats/data/property.interface';

export class Snowplow2StatsAdapterListingStatusType implements StatsAdapterInterface {
  /**
   *
   * @param rawData
   */
  constructor(private rawData: StatsDataEntityInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): ListingStatusType {
    if ((<StatsDataAgentInterface>this.rawData).isSmartAdAgent) {
      return 'featured_agent';
    }

    if ((<StatsDataPropertyInterface>this.rawData).listingStatus === 'smart_ad') {
      return 'smartad';
    }

    return (<StatsDataPropertyInterface>this.rawData).listingStatus || '';
  }
}
